import {
  enableProdMode,
  inject,
  Injectable,
  LOCALE_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection
} from '@angular/core';
import { environment } from './environments/environment';

import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  provideMissingTranslationHandler,
  provideTranslateService,
  TranslateService,
  Translation
} from '@ngx-translate/core';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withComponentInputBinding, withDebugTracing, withInMemoryScrolling } from '@angular/router';
import { APP_ROUTES } from './app/app-routes';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AppConfig, initConfig } from './app/app.config';
import { apikeyInterceptor } from './app/apikey.interceptor';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { TRANSLATE_SERVICE_TOKEN } from '@tribeauto/ngx-mobilite-material';

// to use the local format like Date, Currency...
registerLocaleData(localeEn, 'en');
registerLocaleData(localeFr, 'fr');

@Injectable()
export class MyMissingTranslationHandler extends MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    return `[Missing translation for key:  ${params.key}]`;
  }
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      APP_ROUTES,
      withDebugTracing(),
      withComponentInputBinding(),
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })
    ),
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    provideHttpClient(withInterceptors([apikeyInterceptor])),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'en',
      lang: 'fr',
      missingTranslationHandler: provideMissingTranslationHandler(MyMissingTranslationHandler)
    }),
    AppConfig,
    provideAppInitializer(() => {
      const initializerFn = initConfig(inject(AppConfig));
      return initializerFn();
    }),
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    {
      provide: TRANSLATE_SERVICE_TOKEN,
      useFactory: (translateService: TranslateService): { get: (key: string) => Translation } => {
        return {
          get: (key: string) => translateService.instant(key)
        };
      },
      deps: [TranslateService]
    }
  ]
}).catch(err => console.log(err));
